/* eslint-disable no-unused-vars */

export const White = "#FFFFFF";
export const Black = "#000000";

export const Blue1 = "#8DCFF0";
export const Blue1b = "#5ADCED";
export const Blue2 = "#5ABCED";
export const Blue3 = "#1498D8";
export const Blue4 = "#0575AD";
export const Blue5 = "#021EBB";

export const Grey1 = "#FFFFFF";
export const Grey1b = "#F7F9FC";
export const Grey2 = "#EDEFF3";
export const Grey3 = "#D8DDE4";
export const Grey3b = "#CBCBCB";
export const Grey4 = "#BAC3CE";
export const Grey5 = "#A8A9AF";
export const Grey6 = "#7B8291";
export const Grey6b = "#757575";
export const Grey7 = "#525968";
export const Grey8 = "#262837";
export const Grey9 = "#757575";
export const Grey10 = "#F7F9FC";
export const Grey17 = "#1F2430";

export const Red1 = "#F096Ad";
export const Red2 = "#EC6759";
export const Red3 = "#E74C3C";
export const Red4 = "#BD2930";
export const Red5 = "#730E03";

export const Yellow1 = "#FDE776";
export const Yellow2 = "#FDDC3F";
export const Yellow3 = "#F1C40F";
export const Yellow4 = "#BC932C";
export const Yellow5 = "#876D27";

export const Green1 = "#98EDBB";
export const Green2 = "#61E097";
export const Green3 = "#00D65B";
export const Green4 = "#00A044";
export const Green5 = "#006a2D";

export default function styles() {
    return ({
        assistiveText: {
            fontSize: "12px",
            color: Grey6,
        },
        underNarrativeText: {
            fontSize: "12px",
            color: Grey6,
        },
        selectPage: {
            fontSize: 13,
            marginLeft: 2,
            color: Grey7,
            fontWeight: 600,
            textAlign: "center",
            "& svg": {
                width: 18,
                height: 18,
                marginTop: 3,
                marginRight: 2,
                color: Blue3,
            },
            "& .MuiInput-input": {
                padding: "8px 18px 8px 8px",
            },
        },
        multiSelect: {
            "& legend": {
                visibility: "visible",
                "& span": {
                    backgroundColor: "#FFFFFF",
                    transform: "translate(2px, -6px)",
                    position: "fixed",
                    color: Grey6b,
                },
            },
        },
        tableRow: {
            "& .edit-svg": {
                visibility: "hidden",
            },
            "&.MuiTableRow-hover:hover": {
                "& .edit-svg": {
                    visibility: "visible",
                },
            },
        },
        tableHeader: {
            fontSize: "14px",
            fontWeight: 500,
            color: Grey6,
            border: 0,
        },
        tableCell: {
            fontSize: "14px",
            fontWeight: 400,
            color: Grey8,
            border: 0,
        },
        longLabel: {
            width: 310,
        },
        containerMargin: {
            paddingLeft: "30px",
            paddingRight: "30px",
        },
        containerMargin2: {
            paddingLeft: "0px",
            paddingRight: "0px",
        },
        TableListFocus: {
            display: "block",
            width: "100%",
            height: "100%",
            overflow: "scroll",
        },
        TableListNonFocus: {
            display: "block",
            width: "100%",
            height: "100%",
            overflow: "scroll",
        },
        DetailBodyContentFocus: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            paddingTop: "10px",
        },
        DetailBodyContentNonFocus: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            paddingTop: "10px",
        },
        DetailHeaderControlsLeft: {
            fontSize: "14pt",
            color: "#888888",
            width: "300px",
            margin: "4px 0 0 10px",
            overflow: "hidden",
        },
        DetailContent: {
            display: "block",
            width: "100%",
            height: "100%",
        },
        DetailToolbarContentFocus: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "33px",
            borderLeft: "2px solid #AAAAAA",
            borderRight: "2px solid #AAAAAA",
            padding: "12px 0 10px 0",
            borderBottom: "1px solid #DDDDDD",
        },
        DetailHeaderControlsMenu: {
            fontSize: "10pt",
            color: "#FFFFFF",
            width: "300px",
            margin: "1px 0 0 10px",
        },
        DetailHeaderControlsYearMenu: {
            fontSize: "10pt",
            color: "#FFFFFF",
            width: "100px",
            margin: "1px 0 0 10px",
        },
        DetailHeaderControlsMonthMenu: {
            fontSize: "10pt",
            color: "#FFFFFF",
            width: "100px",
            margin: "1px 0 0 10px",
        },
    });
}